import { ArticleOptionsServices } from '../../global';
import { FT5_OFFERS_ARTICLE_OPTION_CHANGE } from '../../_common/client/offers-tracking';
import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersArticleOptionsComponent extends BaseComponent2 {
    public rootSelector = '.js_of_offers-article-options';

    private variationId?: string;
    private useAvailabilityDetailSlowFeature = false;
    private deliveryOnDemand = false;

    public async onReloadComponentEvent(): Promise<void> {
        this.variationId = this.getRootElement().dataset.variationId;
        this.deliveryOnDemand = this.getRootElement().dataset.variationDeliveryOnDemand === 'true';
        this.useAvailabilityDetailSlowFeature = this.getRootElement().dataset.useAvailabilityDetailSlowFeature === 'true';

        /*                                                                               */
        this.emitSelectedForOrdering();

        this.getCheckBoxes().forEach((chkBox: HTMLInputElement) => {
            /*                                                                       */
            this.updateWarningState(chkBox);

            chkBox.addEventListener('change', () => this.onChkBoxChanged(chkBox));
        });
    }

    private onChkBoxChanged(chkBox: HTMLInputElement) {
        this.updateWarningState(chkBox);
        this.emitSelectedForTracking(chkBox);
        this.emitSelectedForOrdering();
    }

    /**
 *
 */
    private emitSelectedForTracking(chkBox: HTMLInputElement): void {
        o_global.eventQBus.emit(FT5_OFFERS_ARTICLE_OPTION_CHANGE, {
            variationId: this.variationId,
            changedServiceId: chkBox.dataset.articleOptionId,
            isSelected: chkBox.checked,
        });
    }

    /**
 *
 */
    private emitSelectedForOrdering(): void {
        o_global.eventQBus.emit(`ft5.offersArticleOptionChange.${this.variationId}`, {
            services: this.getSelectedServicesForOrdering().services,
        });
    }

    private getCheckBoxes(): HTMLInputElement[] {
        return this.getChildElements('.js_of_offers-article-options__checkbox-input') as HTMLInputElement[];
    }

    private updateWarningState(chkBox: HTMLInputElement): void {
        let showWarning: boolean;
        if (this.useAvailabilityDetailSlowFeature) {
            const notApplicableForDesiredDate = chkBox.dataset.deliveryForDesiredDate === 'false';
            showWarning = chkBox.checked && this.deliveryOnDemand && notApplicableForDesiredDate;
        } else {
            const isOptionDeliveryLonger24h = chkBox.dataset.deliveryForDesiredDate === 'false';
            showWarning = chkBox.checked && isOptionDeliveryLonger24h;
        }
        this.setWarningVisibility(chkBox, showWarning);
    }

    private setWarningVisibility(chkBox: HTMLInputElement, shouldShowWarning: boolean): void {
        const warningElem = chkBox.parentElement?.parentElement?.querySelector<HTMLDivElement>('.js_of_offers-article-options__warning');
        if (!warningElem) {
            throw new Error('cant find warning element for input' + chkBox.id);
        }

        if (shouldShowWarning) {
            warningElem.classList.remove('pl_hidden');
        } else {
            warningElem.classList.add('pl_hidden');
        }
    }

    private getSelectedServicesForOrdering(): ArticleOptionsServices {
        const services = this.getCheckBoxes()
            .filter(chkBox => chkBox.checked)
            .map(chkBox => ({ uuid: chkBox.dataset.articleOptionId ?? '' }));

        return { services };
    }
}
